__turbopack_context__.v({
  "container": "PlPartnersTypeformModal-module__rJSvpW__container",
});
